// extracted by mini-css-extract-plugin
export default {"date":"WorkshopManagement_date__kBXFI"};